import { z } from 'zod';
export const RoleSchema = z.enum(['RENTER', 'OWNER_STAFF', 'ADMIN']);
/** Pilot licence class. Capability order: NONE < A < B < C. */
export const LicenseClassSchema = z.enum(['NONE', 'A', 'B', 'C']);
export const AirshipClassSchema = z.enum(['A', 'B', 'C']);
export const AirshipStatusSchema = z.enum(['ACTIVE', 'MAINTENANCE', 'RETIRED']);
export const ReservationStateSchema = z.enum([
    'DRAFT',
    /** Slot is held while an Approver decides. Added by change C02 (spec v0.2). */
    'PENDING_APPROVAL',
    'CONFIRMED',
    'IN_FLIGHT',
    'COMPLETED',
    'CANCELLED',
    /** Refused by the Approver, with a reason. Added by change C02 (spec v0.2). */
    'REJECTED',
    'EXPIRED',
]);
export const NotificationStatusSchema = z.enum(['SENT', 'FAILED', 'RETRY']);
export const NotificationChannelSchema = z.enum(['EMAIL', 'SMS', 'WEBHOOK']);
/**
 * BR-02: states in which a reservation holds its airship and therefore takes part
 * in the overlap and turnaround rules.
 *
 * This is the ONLY definition. Backend rule evaluation, the availability endpoint,
 * the state machine and the frontend all read it from here; the database exclusion
 * constraint in the migrations repeats it in SQL, which is the one duplicate the
 * type system cannot catch (architectural driver AD-2 for C03).
 *
 * PENDING_APPROVAL blocks: a slot awaiting an Approver's decision is held, so the
 * renter cannot lose it while waiting. The price of that is a deadline — see
 * BR-09 and OP-06 in docs/specification.md.
 */
export const BLOCKING_RESERVATION_STATES = [
    'PENDING_APPROVAL',
    'CONFIRMED',
    'IN_FLIGHT',
];
/** BR-04: states a reservation can be cancelled from, while `now < startAt`. */
export const CANCELLABLE_RESERVATION_STATES = [
    'DRAFT',
    'PENDING_APPROVAL',
    'CONFIRMED',
];
export const isBlockingState = (state) => BLOCKING_RESERVATION_STATES.includes(state);
export const LICENSE_RANK = {
    NONE: 0,
    A: 1,
    B: 2,
    C: 3,
};
export const AIRSHIP_CLASS_REQUIRED_LICENSE = {
    A: 'A',
    B: 'B',
    C: 'C',
};
//# sourceMappingURL=enums.js.map